import { useContext } from "react"
import { Navigate, useLocation } from "react-router-dom"
import { DiMaProgress } from "../../components/DiMaProgress"
import { HashTabSection } from "../../components/Helpers"
import { UserContext } from "../../context/UserContext"
import {
  AccessLevel,
  DimaFeatureShortNameEnum,
  hasUserAccessToFeature,
} from "../../models/Authorization"
import { Factories } from "./factories_tab/Factories"
import { FactoryReportSearch } from "./search_tab/FactoryReportSearch"

export function FactoryReportsContainer() {
  const { user, isLoadingUser } = useContext(UserContext)
  const { hash } = useLocation()

  if (isLoadingUser || !user) {
    return <DiMaProgress />
  }

  const canSearch = hasUserAccessToFeature(
    user.authorizations,
    DimaFeatureShortNameEnum.FR,
    AccessLevel.Read
  )
  const canManageFactories = hasUserAccessToFeature(
    user.authorizations,
    DimaFeatureShortNameEnum.FR,
    AccessLevel.Write
  )

  if (!canSearch) {
    return <Navigate to="/" replace />
  }

  if (hash === "#factories" && !canManageFactories) {
    return <Navigate to="/factory-reports#search" replace />
  }

  const tabItems = [
    { id: "search", label: "Search" },
    ...(canManageFactories ? [{ id: "factories", label: "Factories" }] : []),
  ]

  return (
    <HashTabSection
      defaultTab="search"
      tabItems={tabItems}
      tabContent={{
        search: <FactoryReportSearch />,
        ...(canManageFactories ? { factories: <Factories /> } : {}),
      }}
    />
  )
}
